import { getCSSBackgroundFromColor } from '../../utilities/getCSSBackgroundFromColor.js';
import { PREVIEW_ICON_SIZE } from '../../constants.js';
import styles from './SquareColorPreview.scss.js';
import { jsx } from 'react/jsx-runtime';

const ANGLE = 305;
function SquareColorPreview({
  color
}) {
  const background = getCSSBackgroundFromColor(color, ANGLE);
  return /*#__PURE__*/jsx("span", {
    className: styles.ColorPreview,
    style: {
      background,
      height: PREVIEW_ICON_SIZE,
      width: PREVIEW_ICON_SIZE
    }
  });
}

export { SquareColorPreview };
